// src/router/analiseResultadoParametrizacao.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['analise_resultado']

const DEFAULT_URL = '/analise-resultado-parametrizacao';

const analiseResultadoParametrizacaoBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Análise de Resultado - Parametrização',
    to: 'analiseResultadoParametrizacao'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'analiseResultadoParametrizacao',
    component: () => import('@/views/AnaliseResultadoParametrizacao/AnaliseResultadoParametrizacaoListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Análise de Resultado - Parametrização',
      breadcrumb: analiseResultadoParametrizacaoBreadCrumb
    }
  },
  {
    path: `${DEFAULT_URL}/novo`,
    name: 'AnaliseResultadoParametrizacaoNovo',
    component: () => import('@/views/AnaliseResultadoParametrizacao/AnaliseResultadoParametrizacaoForm.vue'),
    meta: {
      roles: ROLES,
      title: 'Nova Análise de Resultado - Parametrização',
      breadcrumb: [
        ...analiseResultadoParametrizacaoBreadCrumb,
        {
          label: 'Nova Análise de Resultado - Parametrização',
          to: 'AnaliseResultadoParametrizacaoNovo'
        }
      ]
    }
  },
  {
    path: `${DEFAULT_URL}/:id/edit`,
    name: 'AnaliseResultadoParametrizacaoEdit',
    component: () => import('@/views/AnaliseResultadoParametrizacao/AnaliseResultadoParametrizacaoForm.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes',
      breadcrumb: [
        ...analiseResultadoParametrizacaoBreadCrumb,
        {
          label: 'Novo',
          to: 'Novo'
        }
      ]
    }
  }
]
